<template>
    <v-layout style="height: 100vh; width: 100vw;">
      <v-navigation-drawer
        nav
        elevation="2"
        v-model="drawer"
        :rail="rail"
        width="300"
        @click="rail = false"
        color="primary"
        class="pt-4 seham-drawer"
      >
       <v-list>
        <v-list-item class="ml-2"
          nav
        >
        <div v-if="rail == false" class="d-flex flex-row justify-start align-self-center">
          <div class="ml-4">
            <v-img  width="80px" height="50px" src="../assets/seham-v2-logo.png"></v-img>
          </div>
          <!-- <div class="font-weight-bold text-h5 mt-2 ml-2 seham-brand" style="font-family: Russo One, sans-serif;">SEHAM</div> -->
        </div>
        <v-img v-else class="ml-n1" src="../assets/seham-revamped-logo.png"></v-img>
        
        </v-list-item>
        <!-- <v-list-item v-if="!rail">
            <v-list-item-title>Words to Filipino Sign Language</v-list-item-title>
        </v-list-item> -->
       </v-list>
        
        <v-list :class="rail ? '': 'pl-8'" density="comfortable" color="secondary" nav>
          <v-list-subheader v-if="!rail" class="text-caption" color="white" style="font-family: Russo One, sans-serif;">MENU</v-list-subheader>
          <v-list-item prepend-icon="mdi-view-dashboard" router :to="'dashboard'" class="mb-5 pa-2">
             <v-list-item-title class="text-subtitle-2" style="font-family: Russo One, sans-serif">Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-account-multiple-check" router :to="'account-verification'" class="mb-5 pa-2">
             <v-list-item-title class="text-subtitle-2" style="font-family: Russo One, sans-serif">Account Verification</v-list-item-title>
          </v-list-item>

          <v-list-item prepend-icon="mdi-currency-usd" router :to="'gtb'" class="mb-5 pa-2">
            <v-list-item-title class="text-subtitle-2 text-white" style="font-family: Russo One, sans-serif">Guess The Balance</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-trophy-award" router :to="'rewards'" class="mb-5 pa-2">
            <v-list-item-title class="text-subtitle-2 text-white" style="font-family: Russo One, sans-serif">Wager Rewards</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item prepend-icon="mdi-arm-flex" router :to="'challenges'" class="mb-5">
             <v-list-item-title class="text-subtitle-1" style="font-family: Saira Condensed, sans-serif">Challenges</v-list-item-title>
          </v-list-item> -->
          <v-list-subheader v-if="!rail" class="text-caption" color="white" style="font-family: Russo One, sans-serif;">STORE</v-list-subheader>
          <v-list-item prepend-icon="mdi-bulletin-board" router :to="'points-checker'" class="mb-5">
             <v-list-item-title class="text-subtitle-2" style="font-family: Russo One, sans-serif">Points Checker</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-storefront" router :to="'products'" class="mb-5">
             <v-list-item-title class="text-subtitle-2" style="font-family: Russo One, sans-serif">Products</v-list-item-title>
          </v-list-item>
          <v-list-item prepend-icon="mdi-cart" router :to="'purchases'" class="mb-5">
             <v-list-item-title class="text-subtitle-2" style="font-family: Russo One, sans-serif">Purchases</v-list-item-title>
          </v-list-item>
          <v-list-subheader v-if="!rail" class="text-caption" color="white" style="font-family: Russo One, sans-serif;">CHAT</v-list-subheader>
          <v-list-item prepend-icon="mdi-chat" router :to="'chat'" class="mb-5">
             <v-list-item-title class="text-subtitle-2" style="font-family: Russo One, sans-serif">Chat</v-list-item-title>
          </v-list-item>

        </v-list>
      </v-navigation-drawer>
      <v-main class="overflow-auto main-bg">
        <v-app-bar app color="primary" :elevation="4" class="seham-appbar">
          <template v-slot:prepend>
            <v-app-bar-nav-icon @click="drawer ? rail = !rail : rail = false; drawer = true"></v-app-bar-nav-icon>
          </template>
          
          <!-- <v-app-bar-title class="font-weight-medium">{{ $route.meta.title }}</v-app-bar-title> -->
          <template v-slot:append>
          <v-btn
            id="menu-activator"
            class="admin-menu-btn"
            elevation="0"
            rounded="xl"
            height="50"
          >
          <v-avatar>
            <v-img src="../assets/admin-user.png"></v-img>
              <!-- <v-img v-if="!$store.state.user.picture" src="../assets/admin-user.png"></v-img>
              <v-img v-else :src="$store.state.user.picture"></v-img> -->
          </v-avatar>
          <!-- <span class="pa-2 blur text-caption" style="font-family: Zen Dots, system-ui;">{{ $store.state.user.username }}</span> -->
           <!-- <span class="pa-2 blur text-caption" style="font-family: Zen Dots, system-ui;">Admin</span> -->
          <span class="pa-2 blur text-subtitle-1" style="font-family: Saira Condensed, sans-serif;">{{ $store.state.user.username }}</span>
          <!-- <span class="pa-2 blur text-subtitle-2">{{ $store.state.user.lname }} {{ $store.state.user.fname[0] }}.</span> -->
          </v-btn>
          <v-menu activator="#menu-activator">
          <v-list bg-color="primary" rounded="lg">
              <v-list-item prepend-icon="mdi-account-edit" @click="showProfile()">
                  <v-list-item-title style="font-family: Saira Condensed, sans-serif;">Profile</v-list-item-title>
              </v-list-item>
              <v-list-item prepend-icon="mdi-logout" @click="logout()">
                  <v-list-item-title style="font-family: Saira Condensed, sans-serif;">Log out</v-list-item-title>
              </v-list-item>
          </v-list>
          </v-menu>
        </template>
        </v-app-bar>
            <div class="pt-6 px-4">
              <h2 style="font-family: Saira Condensed, sans-serif;">{{ $route.meta.title }}</h2>
              <span class="text-subtitle-1" style="font-family: Saira Condensed, sans-serif;">{{ currentTime }}</span>
            </div>
          <router-view/>
      </v-main>
    </v-layout>

    <ProfileDialog ref="ProfileDialog" v-on:logout="logout()"/>
</template>

<script>
import ProfileDialog from '@/components/Dialogs/ProfileDialog.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MainView',
  components: {
    ProfileDialog
  },
  data () {
      return {
        drawer: true,
        rail: false,
        userType: '',
        currentTime: this.getCurrentDate()
      }
    },
    methods: {
        logout(){
            localStorage.removeItem("vuex");
            localStorage.removeItem("seham-admin-accesstoken");
            window.location.reload()
        },
        loadMenu(userType) {
          switch (userType) {
            case 1:
              this.userType = '/admin'
              break; 
          }
        },
        getCurrentDate(){
          const cur_date = new Date();
          const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
          const day = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
          return day[cur_date.getDay()] + ' | ' + month[cur_date.getMonth()] + ' ' + cur_date.getDate() + ', '+ cur_date.getFullYear() + ' | ' + this.formatAMPM(cur_date);
        },
        formatAMPM(date) {
          var hours = date.getHours();
          var minutes = date.getMinutes();
          var seconds = date.getSeconds();
          var ampm = hours >= 12 ? 'pm' : 'am';
          hours = hours % 12;
          hours = hours ? hours : 12;
          minutes = minutes < 10 ? '0'+minutes : minutes;
          seconds = seconds < 10 ? '0'+seconds : seconds;
          var strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
          return strTime;
        },
        showProfile(){
          this.$refs.ProfileDialog.initView()
        }
    },
    mounted() {
      // this.loadMenu(this.$store.state.user.type)
      setInterval(() => {
        this.currentTime = this.getCurrentDate();
      }, 1000);
      const isTabletOrPhone = window.matchMedia("(max-width: 1024px)").matches;
        if (isTabletOrPhone) {
           this.drawer = false
        } else {
            this.drawer = true
        }
    }
});
</script>
<style scoped>

@media (max-width: 767px) {
  .blur {
    display: none;
  }
}

.hide-scrollbar {
  /* Hide scrollbar for WebKit browsers (e.g., Chrome, Safari) */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none; /* Hide scrollbar for WebKit browsers */
}

.main-bg {
	background-image:
    radial-gradient(circle at 24% 12%, rgba(246, 216, 74, 0.16), transparent 28%),
    radial-gradient(circle at 82% 10%, rgba(117, 94, 29, 0.22), transparent 32%),
    radial-gradient(circle at 48% 46%, rgba(246, 216, 74, 0.07), transparent 36%),
    linear-gradient(180deg, #050504 0%, #020202 100%);
	background-repeat: no-repeat;
	background-size: cover;
  height: 100vh;
}

.seham-brand {
  background: linear-gradient(135deg, #7b6425 0%, #f6d84a 75%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  letter-spacing: 0;
  text-shadow: 0 0 24px rgba(246, 216, 74, 0.2);
}

.seham-drawer {
  border-right: 1px solid rgba(246, 216, 74, 0.18);
  background:
    radial-gradient(circle at 18% 10%, rgba(246, 216, 74, 0.16), transparent 30%),
    linear-gradient(180deg, #080806 0%, #020202 100%) !important;
}

.seham-appbar {
  border-bottom: 1px solid rgba(246, 216, 74, 0.16);
  background:
    linear-gradient(90deg, rgba(5, 5, 4, 0.98), rgba(18, 16, 10, 0.96)),
    linear-gradient(135deg, rgba(246, 216, 74, 0.11), rgba(90, 72, 22, 0.14)) !important;
}

.admin-menu-btn {
  background: #f7cd45 !important;
  border: 1px solid rgba(247, 205, 69, 0.72);
  color: #000000 !important;
}

:deep(.v-list-item) {
  border-radius: 8px !important;
}

:deep(.v-list-item--active) {
  background: linear-gradient(135deg, rgba(85, 69, 25, 0.96), rgba(246, 216, 74, 0.88)) !important;
  color: #080a07 !important;
  box-shadow: 0 10px 28px rgba(246, 216, 74, 0.18);
}

:deep(.v-list-item--active .v-list-item-title),
:deep(.v-list-item--active .v-icon) {
  color: #080a07 !important;
}

:deep(.v-list-item:not(.v-list-item--active):hover) {
  background: rgba(246, 216, 74, 0.08) !important;
}
</style>
